import { atom } from "jotai";
import type { Operation } from '../types/Operation';

export const openAssignmentDialogAtom = atom(false);
export const selectedOperationIdsAtom = atom<Operation[]>([]);
export const assignTeamMembersAtom = atom<number[]>([]);
export const syncTeamMembersAtom = atom<number[]>([]);
export const enableAssignmentButtonAtom = atom(false);
export const selectedTeamAtom = atom<string>('');